import { useEffect, useState } from 'react';
import { api } from './api';

export function useBankConfig() {
  const [state, setState] = useState({ loading: true, provider: null, liveMode: false, error: '' });
  useEffect(() => {
    let active = true;
    api('/bank/capabilities').then((data) => {
      if (!['alfa', 'tochka'].includes(data?.provider)) throw new Error('Не удалось определить банк проекта');
      if (active) setState({ ...data, loading: false, error: '' });
    }).catch((error) => {
      if (active) setState({ loading: false, provider: null, error: error.message || 'Не удалось загрузить настройки банка' });
    });
    return () => { active = false; };
  }, []);
  return { ...state, isTochka: state.provider === 'tochka' };
}
